import React from "react"

import { FileText, MapPin, Package, Truck } from "lucide-react"

import { useAuth } from "@/contexts/AuthContext"
import { formatCost } from "@/lib/routeCostCalculation"

export interface PlanningListTotals {
  routes: number
  stops: number
  volume: number
  cost: number
}

const PlanningListStats: React.FC<{ totals: PlanningListTotals }> = ({ totals }) => {
  const { can } = useAuth()
  return (
    <div className="bg-white border-b border-palette-jungleGreen200 p-4 flex-shrink-0">
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center">
            <Truck className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <div className="text-xs text-palette-jungleGreen500 uppercase">Routes</div>
            <div className="text-lg font-bold text-palette-jungleGreen900">{totals.routes}</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-lg bg-emerald-50 flex items-center justify-center">
            <MapPin className="w-5 h-5 text-emerald-600" />
          </div>
          <div>
            <div className="text-xs text-palette-jungleGreen500 uppercase">Stops</div>
            <div className="text-lg font-bold text-palette-jungleGreen900">{totals.stops}</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-lg bg-purple-50 flex items-center justify-center">
            <Package className="w-5 h-5 text-purple-600" />
          </div>
          <div>
            <div className="text-xs text-palette-jungleGreen500 uppercase">Est. Volume</div>
            <div className="text-lg font-bold text-palette-jungleGreen900">
              {totals.volume.toLocaleString()}
            </div>
          </div>
        </div>
        {can.costs && (
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-lg bg-amber-50 flex items-center justify-center">
              <FileText className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <div className="text-xs text-palette-jungleGreen500 uppercase">Est. Cost</div>
              <div className="text-lg font-bold text-palette-jungleGreen900">
                {formatCost(totals.cost)}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PlanningListStats
